export default __webpack_public_path__ + "static/media/1824.64e93f08.png";